import React from 'react';
import { ChipField, useRecordContext } from 'react-admin';
import { leadsFields } from '../leads.model';

const StatusField = (props) => {
  const record = useRecordContext();

  const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case 'active':
        return 'info';
      case 'signed_up':
        return 'warning';
      case 'enrolled':
        return 'success';
      case 'reactivated':
        return 'secondary';
      default:
        return 'default';
    }
  };

  if (!record) return null;

  return (
    <ChipField
      {...props}
      record={record}
      source={leadsFields.status}
      color={getStatusColor(record.status)}
    />
  );
};

export default StatusField;
